import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import Upload, { RcFile } from "antd/lib/upload";
import { Button, Modal, Typography } from "antd";
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { useSubCategoriesDocumentDetails } from "./UsefulTipsPageContent.hooks";
import { fields } from "../../constants";

const UsefullTipPageContent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);
  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails();

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
  }, [query.get("id")]);
  useEffect(() => {
    refetchSubCategories();
  }, [])

  const epcApplicationsFormConfig: FormConfig = {
  initialValues: {
    title:
      decodeHTML(editSubCategoriesById?.payload?.title) ||
      decodeHTML(editSubCategories?.title) ||
      "",
    title_ms:
      decodeHTML(editSubCategoriesById?.payload?.title_ms) ||
      decodeHTML(editSubCategories?.title_ms) ||
      "",
    title_zh:
      decodeHTML(editSubCategoriesById?.payload?.title_zh) ||
      decodeHTML(editSubCategories?.title_zh) ||
      "",
    published:
      editSubCategoriesById?.payload?.published ??
      editSubCategories?.published ??
      false,
  },
    fields: fields.usefulTipsPageContent
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {

    const payload = {
      action: action,
      method: method,
      module: "Home Page",
      subModule: "usefulTips_usefulTipsPageContent",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.id || editSubCategoriesById?.payload?.id }),
        ...data,
        published: true
      },
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
    isLoading={isLoadingSubCategories || drilldownLoading}
    config={epcApplicationsFormConfig}
    onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
        data,
        `${passengerHost}/api/get-useful-tips-header-taxonomy-crud-api-data/${editSubCategories?.id || editSubCategoriesById?.payload?.id}`,
        "UPDATE",
        "PATCH",
        buttonValue == "save" ? "DRAFT" : "PENDING",
        reviewNotes
        )
    }
    defaultReviewNotes="Kindly review this Homepage"
    />
  );
};

export default UsefullTipPageContent;
